/**
 * The page says whose it is only when Node served it, and then the app and the API share an
 * origin. The dev server on plain `localhost` or an IP address keeps calling the API at its own
 * address. A church's address in development, `*.localhost` or
 * `*.nip.io` from another machine, goes through the dev server's proxy, as production does.
 */
const sameOrigin =
    window.__CHURCH__ !== undefined ||
    (import.meta.env.DEV && /\.(localhost|nip\.io)$/.test(window.location.hostname));

const apiHost =
    "//" + (import.meta.env.VITE_API_HOST || window.location.hostname) + ":" + import.meta.env.VITE_API_PORT;

export const API_URL = sameOrigin ? `//${window.location.host}/api` : apiHost;

/** Sockets have their own path, so they connect to the origin rather than under the API's */
export const SOCKET_URL = sameOrigin ? `//${window.location.host}` : apiHost;
